import Modal from "react-bootstrap/Modal";
import {
  customStyle,
  styleEnd,
  styleStart,
} from "../../algorithms/styleDirection";
import DateInput from "../sharedComponents/datesInputs/date";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import Lang from "../../userPreferences/staticWords";
import TextArea from "../sharedComponents/textarea/textArea";
import TextInput from "../sharedComponents/inputs/textInput";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import {
  formikSetup,
  formikValidation,
  initialValues,
  validationSchema,
} from "./formikValidation";
import Button from "../sharedComponents/buttons/button";
import { addTaskForm } from "../../API/store/actions/tasks";
import { useSelector } from "react-redux";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
import { englishDateTime } from "../../algorithms";
import Switch from "./../sharedComponents/switch/switch";
import { addNotificatonForm } from "../../API/store/actions/sharek";
import DateTimeInput from "./../sharedComponents/datesInputs/dateTime";
import MembersList, { removeItem } from "../../algorithms/listsAlogrithms";

const CreateNewNotification = (props) => {
  const {
    onHide,
    communityId,
    setProcAdded,
    procAdded,
    formMembers,
    setMembersList,
    membersList,
  } = props;
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");
  const [startDateError, setStartDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);

  const userToken = useSelector((state) => state.login.userToken);

  const [disable, setDisable] = useState(false);
  const [listError, setListError] = useState(false);
  const [membersLists, setMembersLists] = useState([]);

  useEffect(() => {
    if (formMembers?.data?.members) {
      setMembersLists(formMembers?.data?.members);
      setMembersList(formMembers?.data?.members);
    }
  }, [formMembers?.data?.members]);

  const saveHandler = async (values) => {
    let formData = new FormData();

    const newData = {
      Title_A: values.Title,
      Title_E: values.Title,
      Description_A: values.Description,
      Description_E: values.Description,
      StartDate: englishDateTime(values.StartDate).split(" ")[0],
      EndDate: englishDateTime(values.EndDate).split(" ")[0],
      SortIndex: values.SortIndex ?? 0,
      Focus: values.Focus,
      Active: true,
      NotificationMembers: values.NotificationMembers,
    };

    for (let [key, value] of Object.entries(newData)) {
      if (key == "NotificationMembers") {
        value.forEach((element) => {
          formData.append("NotificationMembers", element);
        });
      } else formData.append(key, value);
    }

    if (startDateError === false && endDateError === false) {
      if (values.NotificationMembers.length > 0) {
        setListError(false);
        if (disable) {
          return;
        } else {
          setDisable(true);
        }
        let res = await addNotificatonForm(formData, userToken);
        if (res.status <= 206) {
          setStartDate("");
          setEndDate("");
          resetForm();
          onHide();
          setProcAdded(!procAdded);
          setDisable(false);
        } else {
          setDisable(false);
        }
      } else {
        setListError(true);
        setDisable(false);
      }
    }
  };

  const formik = useFormik(
    formikSetup(
      initialValues,
      undefined,
      validationSchema,
      "addNotification",
      saveHandler
    )
  );

  const {
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    values,
    setFieldTouched,
    handleChange,
    resetForm,
  } = formik;

  if (formMembers)
    return (
      <Modal
        // show={show}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        {...props}
        style={{ zIndex: 1000000 }}
        backdrop="static"
      >
        <Modal.Header style={{ direction: getDir(getCurrentLangFromRedux()) }}>
          <Modal.Title id="contained-modal-title-vcenter">
            <div className="d-flex align-items-center">
              <div
                style={{
                  backgroundColor: "white",
                  height: 25,
                  width: 30,
                  borderRadius: "50%",
                }}
                className="d-flex justify-content-center text-center align-items-center px-1 mt-1"
              >
                <img
                  src={"/assets/images/icons/bell (1).png"}
                  width={25}
                  height={25}
                  alt=""
                />
              </div>
              <div className="text-dark">
                <p
                  className="my-0 mx-1"
                  style={{
                    fontSize: 18,
                    textAlign: "justify",
                    color: "#1A73E8",
                  }}
                >
                  {"إضافة إشعار"}
                </p>
              </div>
            </div>
          </Modal.Title>
          <div
            className={`d-flex justify-content-end mt-2 ${styleEnd("m", 3)}`}
          >
            <Icon
              name="times"
              size={22}
              color={"#1A73E8"}
              onclick={() => {
                onHide();
                setStartDate("");
                setEndDate("");
                resetForm();
                setDisable(false);
              }}
            />
          </div>
        </Modal.Header>

        <Modal.Body style={{ direction: getDir(getCurrentLangFromRedux()) }}>
          <form onSubmit={handleSubmit}>
            <TextArea
              name={"Title"}
              containerStyle={"mb-4 col-12 align-items-center"}
              placeholder={Lang.title + "*"}
              rows="3"
              contentStyle={`scroll col-11 p-1`}
              onChange={handleChange}
              errorMessage={formikValidation(touched, errors, "Title")}
            />

            {/* <TextArea
              name={"Description"}
              containerStyle={"mb-4 col-12 align-items-center"}
              placeholder={"الوصف"}
              rows="4"
              contentStyle={`scroll col-11 p-1`}
              onChange={handleChange}
              errorMessage={formikValidation(touched, errors, "Description")}
            /> */}

            <MembersList
              // onChangeSearch={(e) => {
              //   let searchKey = e.target.value; //HERE FILTER
              //   setMembersList(
              //     [...formMembers?.data?.members].filter((item) =>
              //       item.memberName.includes(searchKey)
              //     )
              //   );
              //   console.log(membersList);
              // }}
              containerStyle="d-flex flex-column mx-xl-4 mx-3 mb-4 col-12"
              aboveTitleStyle={`d-flex px-3 col-11 mb-3 ${styleStart("m", 2)}`}
              aboveTitle={"إضافة مشاركين"}
              cardStyle={`d-flex flex-column col-11 px-3 py-2 mx-1 mx-lg-3 mx-xl-4 ${customStyle(
                "TitleCard"
              )}`}
              cardTitle={Lang.Members}
              list={membersLists}
              id={"A"}
              checked={true}
              values={values.NotificationMembers}
              onChange={(e) => {
                if (e.target.checked) {
                  setFieldValue("NotificationMembers", [
                    ...values.NotificationMembers,
                    parseInt(e.target.value),
                  ]);
                  // setTaskMembersLists(
                  //   TaskMembersLists.filter(
                  //     (item) =>
                  //       parseInt(item.memberId) !== parseInt(e.target.value)
                  //   )
                  // );
                  setListError(false);
                } else {
                  // setTaskMembersLists([
                  //   ...TaskMembersLists,
                  //   AdminTaskMembersLists.find(
                  //     (item) =>
                  //       parseInt(e.target.value) === parseInt(item.memberId)
                  //   ),
                  // ]);
                  setFieldValue(
                    "NotificationMembers",
                    removeItem(
                      values.NotificationMembers,
                      parseInt(e.target.value)
                    )
                  );
                  if (values.NotificationMembers.length > 0) {
                    setListError(false);
                  } else {
                    setListError(true);
                  }
                }
              }}
              listError={listError}
            />

            {/* <div className="d-flex flex-xl-row justify-content-center align-items-center align-items-xl-start col-12 flex-column mt-4">
              <div
                className={`d-flex flex-column align-items-center col-12 my-2 col-xl-7`}
              >
                <p className="mb-3 px-xl-5 px-3 col-12">
                  {Lang.periodTime + "*"}
                </p>
                <div className="d-flex col-12 flex-xl-row flex-column align-items-center align-items-xl-start">
                  <div
                    className={`col-12 col-xl-6 px-4 px-xl-0 me-xl-4 pe-xl-4`}
                  >
                    <DateTimeInput
                      errorMessage={
                        formikValidation(touched, errors, "StartDate") ||
                        startDateError === true
                          ? Lang.invalidDate
                          : null
                      }
                      placeholder={Lang.from}
                      containerStyle={`col-12 col-xl-11 ${styleStart(
                        "m",
                        5,
                        "xl"
                      )}`}
                      name={"StartDate"}
                      value={values.StartDate}
                      onChange={(e) => {
                        setFieldValue("StartDate", e);
                        if (values.EndDate)
                          if (new Date(values.EndDate) >= new Date(e)) {
                            setEndDateError(false);
                            setStartDateError(false);
                          } else setStartDateError(true);
                      }}
                      iconPrefix="far"
                      iconName="calendar"
                      iconSize={22}
                    />
                  </div>

                  <div
                    className={`col-12 col-xl-6 px-4 px-xl-0 pe-xl-3 ps-xl-4`}
                  >
                    <DateTimeInput
                      errorMessage={
                        formikValidation(touched, errors, "EndDate") ||
                        endDateError === true
                          ? Lang.invalidDate
                          : null
                      }
                      placeholder={Lang.to}
                      containerStyle={`col-12 col-xl-11 ${styleStart(
                        "m",
                        3,
                        "xl"
                      )}`}
                      value={values.EndDate}
                      onChange={(e) => {
                        setFieldValue("EndDate", e);
                        if (values.StartDate)
                          if (new Date(values.StartDate) <= new Date(e)) {
                            setEndDateError(false);
                            setStartDateError(false);
                          } else setEndDateError(true);
                      }}
                      iconPrefix="far"
                      iconName="calendar"
                      iconSize={22}
                    />
                  </div>
                </div>
              </div>

              <div
                className={`d-flex flex-column align-items-center col-xl-3 col-12 me-xl-3 my-2`}
              >
                <p className="mb-3 px-3 px-xl-1 col-xl-8">{Lang.SortIndex}</p>
                <div
                  className={`d-flex flex-xl-row flex-column align-items-xl-center col-xl-10 col-12 ms-xl-0 px-4 px-xl-0`}
                >
                  <div
                    className={`d-flex align-items-xl-center justify-content-center col-12 mb-2`}
                  >
                    <TextInput
                      name={"SortIndex"}
                      value={values.SortIndex}
                      onChange={handleChange}
                      hiddenPlaceholder={Lang.SortIndex}
                      containerStyle={"col-xl-10 col-6"}
                      type={"number"}
                      disable={false}
                      min={0}
                      max={100}
                    />
                  </div>
                </div>
              </div>

              <div
                className={`d-flex my-2 col-xl-2 col-12 align-self-center justify-content-center justify-content-xl-start mt-xl-5 mt-3`}
              >
                <div style={{ fontSize: 18 }} className="mx-2">
                  مميز
                </div>
                <Switch
                  checked={values.Focus}
                  name={"Focus"}
                  onClick={() => {
                    setFieldValue("Focus", !!!values.Focus);
                  }}
                />
              </div>
            </div> */}

            <div className="d-flex flex-sm-row justify-content-center mt-5 mb-3 col-12">
              <Button
                containerStyle="col-3 mx-3"
                disable={disable}
                content={disable ? Lang.saving : Lang.save}
                type={"submit"}
                buttonStyleType={"solid"}
              />

              <Button
                content={Lang.cancel}
                containerStyle="col-3 mx-3"
                onClick={() => {
                  onHide();
                  setStartDate("");
                  setEndDate("");
                  resetForm();
                  setDisable(false);
                }}
              />
            </div>
          </form>
        </Modal.Body>
      </Modal>
    );
  else return <></>;
};
export default CreateNewNotification;
